'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')
var options = {
  //----测试的时候用这个，因为要跳2下取微信的openid----leipan
  version: 'prod', // dev, test, prod
  path: {
    // 静态资源路径，默认:localhost,赋值:localhost/test/
    assets: '/',
    // 路由二级路径，默认:localhost,赋值:localhost/test/
    router: null
  },
  dev: {
    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',          //----发版的时候用这个

    proxyTable: {},
    // Various Dev Server settings
    //host: 'mm-hyss.booksfor.net', // can be overwritten by process.env.HOST
    host: 'localhost', // can be overwritten by process.env.HOST
    //host: '192.168.168.163', // can be overwritten by process.env.HOST
    //host: 'm-pdlib.h-read.net',
    port: 9088, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: false,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },
  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),
    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}
//----测试的时候用这个，因为要跳2下取微信的openid----leipan
if (options.version == 'test') {
  options.path.assets = '/test/';
  options.path.router = '/test/';
}
options.dev.assetsPublicPath = options.path.assets;
options.build.assetsPublicPath = options.path.assets;

module.exports = options



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 58